$(document).ready(function(){
	navegacionBannerListadoComercial();
	$(window).resize(function(){
		navegacionBannerListadoComercial();
	});

	function navegacionBannerListadoComercial(){
		if ($(window).width() > 799 ){
			$("section.banner-listado-comercial .swiper").hover(function(){
				$(this).find(".swiper-button-prev").fadeIn();
				$(this).find(".swiper-button-next").fadeIn();
			}, function(){
				$(this).find(".swiper-button-prev").fadeOut();
				$(this).find(".swiper-button-next").fadeOut();
			});
		}		

		$("section.banner-listado-comercial .swiper-button-prev").hover(function(){
				$("section.banner-listado-comercial .swiper-button-prev").animate({ backgroundSize: '80%' }, 1);
			}, function(){
				$("section.banner-listado-comercial .swiper-button-prev").animate({ backgroundSize: '60%' }, 1);
			});

		$("section.banner-listado-comercial .swiper-button-next").hover(function(){
				$("section.banner-listado-comercial .swiper-button-next").animate({ backgroundSize: '80%' }, 1);
			}, function(){
				$("section.banner-listado-comercial .swiper-button-next").animate({ backgroundSize: '60%' }, 1);
			});
	}
});